import { useTeamStore } from '@/stores/team'

import { ResourcePermissionPage } from '../member/components/ResourcePermissionPage'

export function TeamPermissionPage() {
  const teamResID = useTeamStore((s) => s.teamTokenData?.teamResID)
  if (!teamResID) return <div>No team context</div>
  return (
    <ResourcePermissionPage
      scope="team"
      resId={teamResID}
      backTo="/team/member"
      titleTrail={<span></span>}
    />
  )
}
